import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ResponseUnidadEducativaProyectoModel, UnidadEducativaProyectoModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { ProyectoEducativoDataModel, ResponseProyectoEducativoDataModel, ProyectoEducativoFechasActualizacionModel ,ResponseProyectoEducativoFechasActualizacionModel} from 'src/app/model/ProyectoEducativoData.model';
import { environment } from 'src/environments/environment';
import { apiService } from '../../../../service/api.service'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
declare var $: any;
@Component({
  selector: 'app-proyecto-educativo',
  templateUrl: './proyecto-educativo.component.html',
  styleUrls: [
    './proyecto-educativo.component.css'
]
})
export class ProyectoEducativoComponent implements OnInit {
  @Input() simulacion: boolean;
  @ViewChild('modalInforme', { static: true }) modalInforme: TemplateRef<any>;
  dataJardin = new JardinModel();
  uniEducativaProyecto = new UnidadEducativaProyectoModel();
  proyectoEducativoData = new ProyectoEducativoDataModel();
  proyectoEducativoFechasActualizacionData = new ProyectoEducativoFechasActualizacionModel();
  @ViewChild('divSpinner') divSpinner:ElementRef;
  cargando : boolean;
  showButtonFinish: boolean = false;
  showButtonDescargar: boolean = false;
  contexto : boolean;
  ideario : boolean;
  objetivos : boolean;
  evaluacion : boolean;
  completos1:number;
  completos2:number;
  completos3:number;
  completos4:number;
  apiEndpoint = environment.apiEndpoint;
  url:string ;
  urlSafe: SafeResourceUrl;
  status:number;
  fecha1:any;
  fecha2:any;
  fecha3:any;
  fechaTermino:any;
  fechaInicio:any;
  respuesta:any;
    spinnerRef:any;
  constructor(
    private api: apiService,
    private modal: NgbModal,
    private spinnerService: SpinnerService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.contexto = false;
    this.ideario = false;
    this.objetivos = false;
    this.evaluacion = false;
    this.completos1 = 0;
    this.completos2 = 0;
    this.completos3 = 0;
    this.completos4 = 0;
    this.status
    this.cargaInicial()
  }


  cargaInicial(){
    this.cargando = true;
    this.dataJardin = this.api.dataJardin;
    this.unidadEducativa(this.dataJardin);
    this.proyectoEducativo(this.dataJardin);
     this.selectFechas();

  }

  unidadEducativa(dataJardin:JardinModel){
      this.api.API_POST_obtenerUnidadEducaticaProyecto(dataJardin.id).subscribe((response: ResponseUnidadEducativaProyectoModel) => {
        this.uniEducativaProyecto = response.payload;  
      },
      (err) => {
        console.log(err)
      });      
  }

  proyectoEducativo(dataJardin:JardinModel){
    this.api.API_POST_obtenerProyectoEducativoData(dataJardin.id).subscribe((response: ResponseProyectoEducativoDataModel) => {
      this.proyectoEducativoData = response.payload;  
      this.calcularCompletos1();
      this.calcularCompletos2();
      this.calcularCompletos3();
      this.calcularCompletos4();
      if(this.completos1 === 0 && this.completos2 === 0 && this.completos3 === 0 && this.completos4 === 0){
        this.status = 1;
        this.showButtonFinish = false;
        sessionStorage.setItem('guardarEditar', 'true');
      }else if(this.completos1 === 5 && this.completos2 === 6 && this.completos3 === 2 && this.completos4 === 2){
        this.status = 3;
      }else{
        this.status = 2;
        this.showButtonFinish = false;
        sessionStorage.setItem('guardarEditar', 'true');
      }

      if(this.status === 3 && this.proyectoEducativoData.fechaCreacion === null){
        this.showButtonFinish = true;
        sessionStorage.setItem('guardarEditar', 'true');
      }
      if(this.status === 3 && this.proyectoEducativoData.fechaCreacion !== null){
        this.showButtonFinish = false;
        this.showButtonDescargar = true;
        sessionStorage.setItem('guardarEditar', 'false');
      }

      this.cargando = false;
      
    },
    (err) => {
      this.cargando = false;
      console.log(err)
    });  
  }

  calcularCompletos1(){
    if(this.proyectoEducativoData.introduccion.trim() != ""){
      this.completos1 ++;
    }
    let totalAntecedentesGenerales : number = this.proyectoEducativoData.capacidadSalacunaMixta + 
                                              this.proyectoEducativoData.capacidadSalacunaMenor +
                                              this.proyectoEducativoData.capacidadSalacunaMayor + 
                                              this.proyectoEducativoData.capacidadSalacunaNoConvencional + 
                                              this.proyectoEducativoData.capacidadMedioMenor + 
                                              this.proyectoEducativoData.capacidadMedioMayor + 
                                              this.proyectoEducativoData.capacidadTransicion1 + 
                                              this.proyectoEducativoData.capacidadTransicion2 + 
                                              this.proyectoEducativoData.heterogeneo +
                                              this.proyectoEducativoData.capacidadMedioTC + 
                                              this.proyectoEducativoData.capacidadMedioMixto; 
    if(totalAntecedentesGenerales > 0){
      this.completos1 ++;
    }
    let totalAntecedentesEspecificos: number = this.proyectoEducativoData.cantidadDirectora + this.proyectoEducativoData.cantidadEducadora + this.proyectoEducativoData.cantidadTecnico + this.proyectoEducativoData.cantidadAgente + this.proyectoEducativoData.cantidadAdministrativa + this.proyectoEducativoData.cantidadAuxiliar + this.proyectoEducativoData.cantidadManipuladora;
    if(totalAntecedentesEspecificos > 0){
      this.completos1 ++;
    }
    if(this.proyectoEducativoData.resenaHistorica.trim() != ""){
      this.completos1 ++;
    }
    if(this.proyectoEducativoData.entorno.trim() != ""){
      this.completos1 ++;
    }

  }

  calcularCompletos2(){
    if(this.proyectoEducativoData.sello.trim() != ""){
      this.completos2 ++;
    }
    if(this.proyectoEducativoData.vision.trim() != ""){
      this.completos2 ++;
    }
    if(this.proyectoEducativoData.mision.trim() != ""){
      this.completos2 ++;
    }
    if(this.proyectoEducativoData.valores.trim() != ""){
      this.completos2 ++;
    }
    if(this.proyectoEducativoData.definiciones.trim() != ""){
      this.completos2 ++;
    }
    if(this.proyectoEducativoData.perfiles.trim() != ""){
      this.completos2 ++;
    }
  }

  calcularCompletos3(){
    if(this.proyectoEducativoData.objetivosGenerales.trim() != ""){
      this.completos3 ++;
    }
    if(this.proyectoEducativoData.objetivosEstrategicos.trim() != ""){
      this.completos3 ++;
    }
  }

  calcularCompletos4(){

    if(this.proyectoEducativoData.seguimiento.trim() != ""){
      this.completos4 ++;
    }
    if(this.proyectoEducativoData.proyecciones.trim() != ""){
      this.completos4 ++;
    }

  }


  guardar(){
    
    this.api.API_POST_actualizarProyectoEducativoData(this.proyectoEducativoData).subscribe((response: ResponseProyectoEducativoDataModel) => {
      this.proyectoEducativoData = response.payload;   
    },
    (err) => {
      console.log(err)
    }); 
  }

    guardarFechas(){

      let mes : string ='';
      let dia : string ='';
      let fechaInicioVal : Date;
      let error : string ='';
      if(this.fechaInicio === null || this.fechaInicio === '' || this.fechaInicio === undefined || this.fechaInicio.year === 0){

          Swal.fire({
            title: 'Errores de Validación',
            text: 'Debe ingresar Fecha Inicio',
            icon: 'error',
            confirmButtonText: 'OK'
          });
      }else{
      
           

                if(this.fechaInicio.month >0 && this.fechaInicio.month < 10){
                  mes = "0"+this.fechaInicio.month;
                }else{
                  mes = this.fechaInicio.month;
                }

                if(this.fechaInicio.day>0 && this.fechaInicio.day<10){
                  dia = "0"+this.fechaInicio.day;
                }else{
                  dia = this.fechaInicio.day;
                }

                this.proyectoEducativoFechasActualizacionData.fechaInicio =this.fechaInicio.year+'-'+mes+'-'+dia;

                mes = "";
                dia = "";
                fechaInicioVal = new Date(this.proyectoEducativoFechasActualizacionData.fechaInicio);
            

            if(this.fecha1 != null){

                if(this.fecha1.month >0 && this.fecha1.month < 10){
                  mes = "0"+this.fecha1.month;
                }else{
                  mes = this.fecha1.month;
                }

                if(this.fecha1.day>0 && this.fecha1.day<10){
                  dia = "0"+this.fecha1.day;
                }else{
                  dia = this.fecha1.day;
                }


                this.proyectoEducativoFechasActualizacionData.fecha1 =this.fecha1.year+'-'+mes+'-'+dia;

                 mes = "";
                 dia = "";

                
                let fecha1Val = new Date(this.proyectoEducativoFechasActualizacionData.fecha1);

                if (fecha1Val.getTime() - fechaInicioVal.getTime() >= 0) {
                  error = '';
                } else {
                  error = "La Fecha Actualización Año 1, no puede ser anterior a la Fecha Inicio";
                }
                 

            }

            if(error == '' && this.fecha2 != null){

                if(this.fecha2.month >0 && this.fecha2.month < 10){
                  mes = "0"+this.fecha2.month;
                }else{
                  mes = this.fecha2.month;
                }

                if(this.fecha2.day>0 && this.fecha2.day<10){
                  dia = "0"+this.fecha2.day;
                }else{
                  dia = this.fecha2.day;
                }

                this.proyectoEducativoFechasActualizacionData.fecha2 =this.fecha2.year+'-'+mes+'-'+dia;
                mes = "";
                dia = "";

                let fecha2Val = new Date(this.proyectoEducativoFechasActualizacionData.fecha2);

                if (fecha2Val.getTime() - fechaInicioVal.getTime() >= 0) {
                  error = '';
                } else {
                  error = " - La Fecha Actualización Año 2, no puede ser anterior a la Fecha Inicio";
                }

                if (error == '' && this.proyectoEducativoFechasActualizacionData.fecha1 != null && this.proyectoEducativoFechasActualizacionData.fecha1 !=''){
                  let fecha11Val = new Date(this.proyectoEducativoFechasActualizacionData.fecha1);
                  if (fecha2Val.getTime() - fecha11Val.getTime() >= 0) {
                    error = '';
                  } else {
                    error = "La Fecha Actualización Año 2 , no puede ser menor a la Fecha Actualización Año 1";
                  }
                }


            }

            if(error == '' && this.fecha3 != null){

                if(this.fecha3.month >0 && this.fecha3.month < 10){
                  mes = "0"+this.fecha3.month;
                }else{
                  mes = this.fecha3.month;
                }

                if(this.fecha3.day>0 && this.fecha3.day<10){
                  dia = "0"+this.fecha3.day;
                }else{
                  dia = this.fecha3.day;
                }

                this.proyectoEducativoFechasActualizacionData.fecha3 =this.fecha3.year+'-'+mes+'-'+dia;
                mes = "";
                dia = "";

                let fecha3Val = new Date(this.proyectoEducativoFechasActualizacionData.fecha3);
                if (fecha3Val.getTime() - fechaInicioVal.getTime() >= 0) {
                  error = '';
                } else {
                  error =  " - La Fecha Actualización Año 3, no puede ser anterior a la Fecha Inicio";
                }



                if (error == '' && this.proyectoEducativoFechasActualizacionData.fecha1 != null && this.proyectoEducativoFechasActualizacionData.fecha1 !=''){
                  let fecha111Val = new Date(this.proyectoEducativoFechasActualizacionData.fecha1);
                  if (fecha3Val.getTime() - fecha111Val.getTime() >= 0) {
                    error = '';
                  } else {
                    error = "La Fecha Actualización Año 3 , no puede ser menor a la Fecha Actualización Año 1";
                  }
                }


                if (error == '' && this.proyectoEducativoFechasActualizacionData.fecha2 != null && this.proyectoEducativoFechasActualizacionData.fecha2 !=''){
                  let fecha22Val = new Date(this.proyectoEducativoFechasActualizacionData.fecha2);
                  if (fecha3Val.getTime() - fecha22Val.getTime() >= 0) {
                    error = '';
                  } else {
                    error = "La Fecha Actualización Año 3 , no puede ser menor a la Fecha Actualización Año 2";
                  }
                }
            }

            if(error == '' && this.fechaTermino != null){
                if(this.fechaTermino.month >0 && this.fechaTermino.month < 10){
                  mes = "0"+this.fechaTermino.month;
                }else{
                  mes = this.fechaTermino.month;
                }

                if(this.fechaTermino.day>0 && this.fechaTermino.day<10){
                  dia = "0"+this.fechaTermino.day;
                }else{
                  dia = this.fechaTermino.day;
                }
              this.proyectoEducativoFechasActualizacionData.fechaTermino =this.fechaTermino.year+'-'+mes+'-'+dia;
              mes = "";
              dia = "";

                let fechaTerminoVal = new Date(this.proyectoEducativoFechasActualizacionData.fechaTermino);
                if (error == '' && (fechaTerminoVal.getTime() - fechaInicioVal.getTime() >= 0)) {
                  error = '';
                } else {
                  error = "La Fecha de Finalización , no puede ser menor a la fecha de inicio ni de las fechas de actualización";
                }

                if (error == '' && this.proyectoEducativoFechasActualizacionData.fecha3 != null && this.proyectoEducativoFechasActualizacionData.fecha3 !=''){
                  let fecha3Val = new Date(this.proyectoEducativoFechasActualizacionData.fecha3);
                  if (fechaTerminoVal.getTime() - fecha3Val.getTime() >= 0) {
                    error = '';
                  } else {
                    error = "La Fecha de Finalización , no puede ser menor a la fecha de inicio ni de las fechas de actualización";
                  }
                }

                if (error == '' && this.proyectoEducativoFechasActualizacionData.fecha2 != null && this.proyectoEducativoFechasActualizacionData.fecha2 !=''){
                  let fecha2Val = new Date(this.proyectoEducativoFechasActualizacionData.fecha2);
                  if (fechaTerminoVal.getTime() - fecha2Val.getTime() >= 0) {
                    error = '';
                  } else {
                    error = "La Fecha de Finalización , no puede ser menor a la fecha de inicio ni de las fechas de actualización";
                  }
                }

                if (error == '' && this.proyectoEducativoFechasActualizacionData.fecha1 != null && this.proyectoEducativoFechasActualizacionData.fecha1 !=''){
                  let fecha1Val = new Date(this.proyectoEducativoFechasActualizacionData.fecha1);
                  if (fechaTerminoVal.getTime() - fecha1Val.getTime() >= 0) {
                    error = '';
                  } else {
                    error = "La Fecha de Finalización , no puede ser menor a la fecha de inicio ni de las fechas de actualización";
                  }
                }
            }


            if(error !== ''){

                Swal.fire({
                      title: error,
                      icon: 'error',
                      confirmButtonText: 'OK'

                    })
                    
            }else{
                   this.proyectoEducativoFechasActualizacionData.idJardin = this.dataJardin.id;
                  this.spinnerRef = this.spinnerService.start();
                  this.api.API_POST_actualizarFechasActualizacionDocumento(this.proyectoEducativoFechasActualizacionData).subscribe((response: string) => {
                  this.respuesta = response;   
                    
                  },
                  (err) => {
                    console.log(err)
                this.spinnerService.stop(this.spinnerRef);
                Swal.fire({
                      title: 'No se pudo actualizar los datos.',
                      icon: 'error',
                      confirmButtonText: 'OK'

                    })
                    
                  }); 

                  this.spinnerService.stop(this.spinnerRef);
                  Swal.fire({
                        title: 'Actualizado con éxito.',
                        icon: 'success',
                        confirmButtonText: 'OK'

                      })
            }

      }

  }
    selectFechas(){

    this.api.API_GET_selectFechasActualizacionDocumento(this.dataJardin.id).subscribe((response: ResponseProyectoEducativoFechasActualizacionModel) => {
      this.proyectoEducativoFechasActualizacionData = response.payload;   
      
      if(this.proyectoEducativoFechasActualizacionData  != null){

        if(this.proyectoEducativoFechasActualizacionData.fechaInicio != null){
          const fechaInicioD = this.proyectoEducativoFechasActualizacionData.fechaInicio.split('-');
          this.fechaInicio = { year: +fechaInicioD[0], month: +fechaInicioD[1], day: +fechaInicioD[2]}; 
        }

        if(this.proyectoEducativoFechasActualizacionData.fecha1 != null){
          const fecha1D = this.proyectoEducativoFechasActualizacionData.fecha1.split('-');
          this.fecha1 = { year: +fecha1D[0], month: +fecha1D[1], day: +fecha1D[2]}; 
        }

        if(this.proyectoEducativoFechasActualizacionData.fecha2!= null){
          const fecha2D = this.proyectoEducativoFechasActualizacionData.fecha2.split('-');
          this.fecha2 = { year: +fecha2D[0], month: +fecha2D[1], day: +fecha2D[2]}; 
        }

        if(this.proyectoEducativoFechasActualizacionData.fecha3 != null){
          const fecha3D = this.proyectoEducativoFechasActualizacionData.fecha3.split('-');
          this.fecha3 = { year: +fecha3D[0], month: +fecha3D[1], day: +fecha3D[2]}; 
        }

        if(this.proyectoEducativoFechasActualizacionData.fechaTermino != null){
          const fechaTerminoD = this.proyectoEducativoFechasActualizacionData.fechaTermino.split('-');
          this.fechaTermino = { year: +fechaTerminoD[0], month: +fechaTerminoD[1], day: +fechaTerminoD[2]}; 
        }
      }

      if(this.fecha1 == null){

      }

    },
    (err) => {
      console.log(err)
    }); 
      

  }


  irA(){
    this.api.emitDireccionamiento('contacto');
  }

showContexto(){
  this.contexto = true;
}

showIdeario(){
  this.ideario = true;
}

showObjetivos(){
  this.objetivos = true;
}

showEvaluacion(){
  this.evaluacion = true;
}

finalizarInforme(){
  //this.api.API_POST_obtenerUnidadEducaticaProyecto(this.dataJardin.id).subscribe((response: any) => {
  this.api.API_POST_finalizarProyecto(this.dataJardin.id).subscribe((response: any) => {
    this.showButtonFinish = false;
    this.ngOnInit();
  },
  (err) => {
    console.log(err)
  });  
}

imprimir(){
  this.url = this.apiEndpoint + "jardin/imprimirProyectoEducativo/" + this.dataJardin.idJardinPeriodo;
  this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  this.modal.open(this.modalInforme, { size: 'xl' });
}

close(){
  this.modal.dismissAll();
}

  clearDate1(){
    this.fecha1= null;
    this.proyectoEducativoFechasActualizacionData.fecha1 = "";
  }
    clearDate2(){
    this.fecha2= null;
    this.proyectoEducativoFechasActualizacionData.fecha2 = "";
  }
    clearDate3(){
    this.fecha3= null;
    this.proyectoEducativoFechasActualizacionData.fecha3 = "";
  }
    clearDateTermino(){
    this.fechaTermino= null;
    this.proyectoEducativoFechasActualizacionData.fechaTermino = "";
  }
    clearDateinicio(){
    this.fechaInicio= null;
    this.proyectoEducativoFechasActualizacionData.fechaInicio = "";
  }

    soloNumeros(event: KeyboardEvent) {
    const charCode = event.charCode ? event.charCode : event.keyCode;
    // Solo permitir números (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

    validarFechasFinalizar(fechaInicio: Date, fechaFin: Date) {
    let error = '';

    if (fechaInicio != undefined && fechaFin != undefined && fechaInicio != null && fechaFin != null) {

      fechaInicio = new Date(fechaInicio);
      fechaFin = new Date(fechaFin);

      if (fechaFin.getTime() - fechaInicio.getTime() >= 0) {
        error = '';
      } else {
        error = "La fecha Hasta no puede ser anterior a la fecha Desde";
      }

    } else {
      error = "Faltan fechas por completar";
    }
  }
 
}
